/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from '@angular/core';
import { ProductUnregulatedService } from '../../product-unregulated.service';
import {
  IProductUnregulated,
  PRODUCTS_UNREGULATED_TTL_ES
} from '../../product-unregulated.interface';
import { CrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.template';
import { ICrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.interface';

@Component({
  selector: 'pg-product-unregulated',
  templateUrl: './product-unregulated.component.html'
})
export class ProductUnregulatedComponent
  extends CrudTemplate
  implements ICrudTemplate
{
  constructor(private serviceBase: ProductUnregulatedService) {
    super(PRODUCTS_UNREGULATED_TTL_ES, serviceBase);
  }
  ngOnChanges() {
    // console.log('actualizo');
    this.initSubscriptions$();
  }
  ngOnInit() {
    this.table.settings = {
      title: PRODUCTS_UNREGULATED_TTL_ES,
      columns: [
        { header: 'Código', field: 'code' },
        { header: 'Descripción', field: 'name' },
        { header: 'Codigo de barras', field: 'barCode' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IProductUnregulated[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
